import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const TrendAnalysisChart = () => {
  const data = [
    { month: 'Jan', reported: 28, rectified: 24, pending: 4 },
    { month: 'Feb', reported: 32, rectified: 28, pending: 4 },
    { month: 'Mar', reported: 35, rectified: 31, pending: 4 },
    { month: 'Apr', reported: 29, rectified: 26, pending: 3 },
    { month: 'May', reported: 38, rectified: 33, pending: 5 },
    { month: 'Jun', reported: 42, rectified: 37, pending: 5 },
    { month: 'Jul', reported: 45, rectified: 39, pending: 6 }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Reporting Trends</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis dataKey="month" stroke="var(--color-muted-foreground)" />
          <YAxis stroke="var(--color-muted-foreground)" />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: 'var(--color-card)', 
              border: '1px solid var(--color-border)',
              borderRadius: '8px'
            }}
          />
          <Legend />
          <Line type="monotone" dataKey="reported" stroke="#3b82f6" strokeWidth={2} name="Reported" />
          <Line type="monotone" dataKey="rectified" stroke="#22c55e" strokeWidth={2} name="Rectified" />
          <Line type="monotone" dataKey="pending" stroke="#f59e0b" strokeWidth={2} name="Pending" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendAnalysisChart;